import Title from "./Title"
import List from "./List2"

// CancellationPeriod       ExtendedCancellationPeriodهاد الكومبوننت الحاوي لكلشي و هاد مجلو تحت هي

function CancellationPeriod({price,setPrice3}) {
  return (
    <div className=" mx-auto w-full mt-4 py-4 md:px-6 px-2 bg-warm-grey-100 rounded shadow-md" style={{ display: 'none'}}>
      <Title price={price} title="cancellation period 48 hours" sett={setPrice3}/>
      <List/>
      <div className="flex justify-end">
        <p className="md:text-[20px] text-[16px] font-semibold">{price} €</p>
      </div>
    </div>
  )
}

export default CancellationPeriod